module.exports = __webpack_public_path__ + "img/9788991124080.02c641ad.jpg";